<script>
  import dayjs from 'dayjs';
  import utc from 'dayjs/plugin/utc';
  import timezone from 'dayjs/plugin/timezone';

  import { TextInput } from 'carbon-components-svelte';

  import ComboSelect from '../../../components/ComboSelect.svelte';

  dayjs.extend(utc);
  dayjs.extend(timezone);

  export let errors = {},
    touched = {},
    values = {},
    disabled = false,
    setValue;

  const timezones = Intl.supportedValuesOf('timeZone').map((tz) => ({
    id: tz,
    text: tz,
    timezone: dayjs().tz(tz).format('Z'),
  }));

  function onChange(key) {
    return function handleChange({ detail }) {
      setValue(key, detail.selectedId ?? detail);
    };
  }
</script>

<ComboSelect
  labelText="Time zone"
  {disabled}
  required
  items={timezones}
  name="timezone"
  placeholder="Time zone"
  selectedId={values.timezone}
  invalid={touched.timezone && !!errors.timezone}
  invalidText={errors.timezone}
  on:change={onChange('timezone')}
  let:item
>
  {item.text}
  <svelte:fragment slot="item-details">UTC{item.timezone}</svelte:fragment>
</ComboSelect>
<TextInput
  required
  name="mic"
  invalid={touched.mic && !!errors.mic}
  invalidText={errors.mic}
  labelText="MIC"
  placeholder="XNAS"
  value={values.mic}
  maxLength={4}
  readonly={disabled}
  on:input={onChange('mic')}
  autocomplete="off"
/>
<TextInput
  required
  name="countryCode"
  invalid={touched.countryCode && !!errors.countryCode}
  invalidText={errors.countryCode}
  labelText="Country Code"
  placeholder="US"
  value={values.countryCode}
  maxLength={2}
  readonly={disabled}
  on:input={onChange('countryCode')}
  autocomplete="off"
/>
<TextInput
  required
  name="exchangeName"
  invalid={touched.exchangeName && !!errors.exchangeName}
  invalidText={errors.exchangeName}
  labelText="Exchange"
  placeholder="Exchange"
  value={values.exchangeName}
  readonly={disabled}
  on:input={onChange('exchangeName')}
  autocomplete="off"
/>
